// import Vue from "vue";
import axios from "axios";
import { useMainStore } from "../store/main";

// Helper to get store dynamically (required for Pinia in non-component files)
const getStore = () => useMainStore();

export default {
  async get(url, showLoader = true) {
    const store = getStore();
    if (showLoader) store.showLoader();
    var accessToken = store.cognitoInfo.token;
    var jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId:
          store.cognitoInfo.companyid == undefined ||
          store.cognitoInfo.companyid == null ||
          store.cognitoInfo.companyid == "undefined" ||
          store.cognitoInfo.companyid == "null"
            ? ""
            : store.cognitoInfo.companyid,
        crossDomain: true,
      },
    };
    return await axios
      .get(store.apiURL + url, jwtHeader)
      .then((res) => {
        if (showLoader) store.hideLoader();
        return res.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // Vue.prototype.$alert(
          //   "Error|Something went wrong! Please try after sometime."
          // );
          // this.$router.push({name: "Login"});
          window.location.href = "/login";
        } else {
          this.$toast.add({
            severity: "danger",
            summary: "Error",
            detail: "Error|Something went wrong! Please try after sometime",
            life: 3000,
          });
        }
        if (showLoader) store.hideLoader();
        return error;
      });
  },

  async getById(url, id, param = null, param1 = null, showLoader = true) {
    const store = getStore();
    if (showLoader) store.showLoader();
    var getURL = store.apiURL + url + "/" + id;
    if (param != null) {
      getURL += "/" + param;
    }
    if (param1 != null && param1 != "export") {
      getURL += "/" + param1;
    }
    // var accessToken = auth.auth.signInUserSession.idToken.jwtToken;
    var accessToken = store.cognitoInfo.token;
    var jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId:
          store.cognitoInfo.companyid == undefined ||
          store.cognitoInfo.companyid == null ||
          store.cognitoInfo.companyid == "undefined" ||
          store.cognitoInfo.companyid == "null"
            ? ""
            : store.cognitoInfo.companyid,
        crossDomain: true,
        "content-type": "application/x-www-form-urlencoded",
      },
    };
    return await axios
      .get(getURL, jwtHeader)
      .then((res) => {
        if (showLoader) store.hideLoader();
        return res.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // Vue.prototype.$alert(
          //   "Error|Something went wrong! Please try after sometime."
          // );
          // this.$router.push({name: "Login"});
          window.location.href = "/login";
        }
        // Vue.prototype.$alert(
        //   "Error|Something went wrong! Please try after sometime."
        // );
        else {
          this.$toast.add({
            severity: "danger",
            summary: "Error",
            detail: "Error|Something went wrong! Please try after sometime",
            life: 3000,
          });
        }
        if (showLoader) store.hideLoader();
        return error;
      });
  },
  async post(url, model, loader = true) {
    const store = getStore();
    if (loader) store.showLoader();
    // var accessToken = auth.auth.signInUserSession.idToken.jwtToken;
    var accessToken = store.cognitoInfo.token;
    var jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId:
          store.cognitoInfo.companyid == undefined ||
          store.cognitoInfo.companyid == null ||
          store.cognitoInfo.companyid == "undefined" ||
          store.cognitoInfo.companyid == "null"
            ? ""
            : store.cognitoInfo.companyid,
        crossDomain: true,
        timeout: 200000,
      },
    };
    return await axios
      .post(store.apiURL + url, model, jwtHeader)
      .then((res) => {
        if (loader) store.hideLoader();
        return res.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // Vue.prototype.$alert(
          //   "Error|Something went wrong! Please try after sometime."
          // );
          // this.$router.push({name: "Login"});
          window.location.href = "/login";
        }
        // Vue.prototype.$alert(
        //   "Error|Something went wrong! Please try after sometime."
        // );
        // this.$toast.add({
        //   severity: "danger",
        //   summary: "Error",
        //   detail: "Error|Something went wrong! Please try after sometime",
        //   life: 3000,
        // });
        if (loader) store.hideLoader();
        return error;
      })
      .finally(() => {
        if (loader) store.hideLoader();
      });
  },
  async delete(url, id, param = null) {
    const store = getStore();
    store.showLoader();
    var deleteURL = store.apiURL + url + "/" + id;
    if (param != null) {
      deleteURL += "/" + param;
    }
    // var accessToken = auth.auth.signInUserSession.idToken.jwtToken;
    var accessToken = store.cognitoInfo.token;
    var jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId:
          store.cognitoInfo.companyid == undefined ||
          store.cognitoInfo.companyid == null ||
          store.cognitoInfo.companyid == "undefined" ||
          store.cognitoInfo.companyid == "null"
            ? ""
            : store.cognitoInfo.companyid,
        crossDomain: true,
      },
    };
    return await axios
      .delete(deleteURL, jwtHeader)
      .then((res) => {
        store.hideLoader();
        return res.data;
      })
      .catch((error) => {
        // Vue.prototype.$alert(
        //   "Error|Something went wrong! Please try after sometime."
        // );
        if (error.response && error.response.status === 401) {
          // Vue.prototype.$alert(
          //   "Error|Something went wrong! Please try after sometime."
          // );
          // this.$router.push({name: "Login"});
          window.location.href = "/login";
        } else {
          this.$toast.add({
            severity: "danger",
            summary: "Error",
            detail: "Error|Something went wrong! Please try after sometime",
            life: 3000,
          });
        }
        store.hideLoader();
        return error;
      });
  },
};
